import { SkipForwardIcon as PhosphorSkipForwardIcon } from "@phosphor-icons/react/dist/ssr/SkipForward";

import { createAppIcon } from "@/components/createAppIcon";

export const SkipNextIcon = /* @__PURE__ */ createAppIcon(PhosphorSkipForwardIcon);
